/* Maketek header — nav dropdown toggles (keyboard/touch), mobile drawer,
   and predictive search (fetch + debounce + keyboard nav via the Section
   Rendering API, see sections/predictive-search.liquid). */
(function () {
  var header = document.querySelector('[data-header]');
  if (!header) return;

  var toggles = header.querySelectorAll('[data-nav-toggle]');

  function closeAllDropdowns(except) {
    toggles.forEach(function (btn) {
      if (btn === except) return;
      btn.setAttribute('aria-expanded', 'false');
      var item = btn.closest('[data-nav-item]');
      if (item) item.classList.remove('is-open');
    });
  }

  toggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('[data-nav-item]');
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      closeAllDropdowns(btn);
      btn.setAttribute('aria-expanded', String(!isOpen));
      if (item) item.classList.toggle('is-open', !isOpen);
    });
  });

  document.addEventListener('click', function (event) {
    if (!header.contains(event.target)) closeAllDropdowns();
  });

  header.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeAllDropdowns();
      if (document.activeElement && document.activeElement.blur) {
        document.activeElement.blur();
      }
    }
  });

  var drawer = document.getElementById('mobile-drawer');
  var openBtn = header.querySelector('[data-drawer-open]');
  var closeBtn = drawer && drawer.querySelector('[data-drawer-close]');

  if (drawer && openBtn) {
    openBtn.addEventListener('click', function () {
      if (typeof drawer.showModal === 'function') {
        drawer.showModal();
      } else {
        drawer.setAttribute('open', '');
      }
    });
  }

  if (drawer && closeBtn) {
    closeBtn.addEventListener('click', function () {
      if (typeof drawer.close === 'function') {
        drawer.close();
      } else {
        drawer.removeAttribute('open');
      }
    });
  }

  if (drawer) {
    drawer.addEventListener('click', function (event) {
      var rect = drawer.getBoundingClientRect();
      var clickedInPanel =
        event.clientX >= rect.left &&
        event.clientX <= rect.left + rect.width &&
        event.clientY >= rect.top &&
        event.clientY <= rect.top + rect.height &&
        event.target.closest('.mobile-drawer__panel');
      if (!clickedInPanel && typeof drawer.close === 'function') {
        drawer.close();
      }
    });
  }

  /* Predictive search */
  var searchWrap = header.querySelector('[data-predictive-search]');
  if (searchWrap) {
    var searchUrl = searchWrap.getAttribute('data-predictive-search-url');
    var input = searchWrap.querySelector('[data-predictive-search-input]');
    var results = searchWrap.querySelector('[data-predictive-search-results]');

    if (searchUrl && input && results) {
      var debounceTimer = null;
      var currentController = null;
      var activeIndex = -1;
      var lastTerm = '';

      function getOptions() {
        return Array.prototype.slice.call(results.querySelectorAll('a[role="option"]'));
      }

      function closeResults() {
        results.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        activeIndex = -1;
      }

      function setActive(index) {
        var options = getOptions();
        if (!options.length) return;
        options.forEach(function (el) {
          el.classList.remove('is-active');
        });
        var normalized = ((index % options.length) + options.length) % options.length;
        var active = options[normalized];
        active.classList.add('is-active');
        active.scrollIntoView({ block: 'nearest' });
        if (!active.id) active.id = 'predictive-search-option-' + normalized;
        input.setAttribute('aria-activedescendant', active.id);
        activeIndex = normalized;
      }

      function renderResults(term) {
        if (currentController) currentController.abort();
        currentController = typeof AbortController !== 'undefined' ? new AbortController() : null;

        var params = new URLSearchParams({
          q: term,
          'resources[type]': 'product,query,collection',
          'resources[limit]': '4',
          section_id: 'predictive-search'
        });

        fetch(searchUrl + '?' + params.toString(), {
          signal: currentController ? currentController.signal : undefined
        })
          .then(function (response) {
            // section_id ile istek ham HTML döndürür (JSON zarfı yok)
            return response.text();
          })
          .then(function (html) {
            if (!html || !html.trim()) {
              closeResults();
              return;
            }
            results.innerHTML = html;
            results.hidden = false;
            input.setAttribute('aria-expanded', 'true');
            activeIndex = -1;
          })
          .catch(function (error) {
            if (error && error.name === 'AbortError') return;
            closeResults();
          });
      }

      input.addEventListener('input', function () {
        var term = input.value.trim();
        lastTerm = term;
        clearTimeout(debounceTimer);
        if (term.length < 2) {
          closeResults();
          return;
        }
        debounceTimer = setTimeout(function () {
          renderResults(term);
        }, 300);
      });

      input.addEventListener('focus', function () {
        if (lastTerm.length >= 2 && results.innerHTML.trim() !== '') {
          results.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        }
      });

      input.addEventListener('keydown', function (event) {
        var options = getOptions();
        if (event.key === 'ArrowDown') {
          if (!options.length) return;
          event.preventDefault();
          setActive(activeIndex + 1);
        } else if (event.key === 'ArrowUp') {
          if (!options.length) return;
          event.preventDefault();
          setActive(activeIndex - 1);
        } else if (event.key === 'Enter') {
          if (activeIndex > -1 && options[activeIndex]) {
            event.preventDefault();
            window.location.href = options[activeIndex].href;
          }
        } else if (event.key === 'Escape') {
          closeResults();
        }
      });

      document.addEventListener('click', function (event) {
        if (!searchWrap.contains(event.target)) closeResults();
      });
    }
  }
})();
